import { render } from "./RegisterPayment.vue?vue&type=template&id=50a836ae"
import script from "./RegisterPayment.vue?vue&type=script&lang=js"
export * from "./RegisterPayment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__